import { render, staticRenderFns } from "./PaymentIdentifyRecipientModal.vue?vue&type=template&id=02bb8d6c"
import script from "./PaymentIdentifyRecipientModal.vue?vue&type=script&lang=js"
export * from "./PaymentIdentifyRecipientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports